import React from "react";
import { Trans } from "@payping/utils/localeUtils";
import { Col, Collapse, Row } from "@payping/web-components";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";

import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "./styles.module.scss";
import { ScheduleInvoiceProps } from "./type";

const ScheduleInvoice: React.FC<ScheduleInvoiceProps> = ({
  scheduleType,
  startDate,
  count,
  interval,
  dueDateAfterHowManyDay,
  sentCount,
}) => {
  const { t } = useAppTranslation();
  const intervalType = ["day", "week", "month", "year"];
  return (
    <Collapse>
      <Collapse.Panel key={0} header={t("invoice.create.base.scheduleDetails.scheduleInvoice")}>
        <Row justify={"space-between"} gutter={8} className={styles.container}>
          <Col style={{ fontWeight: "lighter" }}>
            <Trans
              values={{
                count,
                dueDateAfterHowManyDay,
                interval,
                scheduleType: scheduleType !== undefined ? t(`invoice.create.base.${intervalType[scheduleType]}`) : "-",
                startDate: toJalali({ date: startDate, toFormat: dateFormats.ui.jalaliDate }).string,
              }}
              components={{ b: <b /> }}
              i18nKey={"invoice.create.base.scheduleDetails.scheduleInvoiceI18nKey1"}
            />
          </Col>
          <Col style={{ fontWeight: "lighter" }}>
            <Trans
              values={{ count: sentCount, sent: count }}
              components={{ b: <b /> }}
              i18nKey={"invoice.create.base.scheduleDetails.scheduleInvoiceI18nKey2"}
            />
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
};

export default ScheduleInvoice;
